import React, { useContext } from 'react';
import ambitionandstatus from "../../../../assets/shapes_svg/output/ambitionandstatus.svg";
import appendix from "../../../../assets/shapes_svg/output/appendix.svg";
import brandway from "../../../../assets/shapes_svg/output/brandway.svg";
import environment from "../../../../assets/shapes_svg/output/environment.svg";
import goals from "../../../../assets/shapes_svg/output/goals.svg";
import governance from "../../../../assets/shapes_svg/output/governance.svg";
import inclusion from "../../../../assets/shapes_svg/output/inclusion.svg";
import social from "../../../../assets/shapes_svg/output/social.svg";
import { CompanyContext, PRINT_WIDTH } from '../';
import { useRef } from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { fontReport } from '../../../../apis/util';

export const TableContents = () => {
  const { companyName } = useContext(CompanyContext);
  const ref = useRef();
  const [width,setWidth] = useState(0)
  useEffect(() => {
    if (!ref.current) return; // wait for the elementRef to be available
    const resizeObserver = new ResizeObserver(() => {
      // Do what you want to do when the size of the element changes
      setWidth(ref.current.clientWidth)
    });
    resizeObserver.observe(ref.current);
    return () => resizeObserver.disconnect(); // clean up 
  }, []);
  return (
    <div className="tablecontents" ref={ref}>
      <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,49/PRINT_WIDTH,"px") }}>Table of Contents</h5>
      <div className="tablecontents__row">
        <img src={ambitionandstatus} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Ambition & Status</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>4</h6>
      </div>
      <div className="tablecontents__row">
        <img src={brandway} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>{companyName} Way</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>6</h6>
      </div>
      <div className="tablecontents__row">
        <img src={goals} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Our Goals</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>7</h6>
      </div>
      <div className="tablecontents__row">
        <img src={environment} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Environment & Our World</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>8</h6>
      </div>
      <div className="tablecontents__row">
        <img src={social} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Social</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>15</h6>
      </div>
      <div className="tablecontents__row">
        <img src={governance} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Governance</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>21</h6>
      </div>
      {/* <div className="tablecontents__row"><img src={sdg}/><h5>Sustainable Development Goals</h5><h6>4</h6></div>
            <div className="tablecontents__row"><img src={circular}/><h5>Circular Economy & Regenerativity</h5><h6>4</h6></div>
            <div className="tablecontents__row"><img src={eugreendeal}/><h5>E.U Green Deal</h5><h6>4</h6></div> */}
      <div className="tablecontents__row">
        <img src={inclusion} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Our Inclusions & Deliminations</h5>
        <h6 style={{ fontSize: fontReport(width,PRINT_WIDTH,26.6/PRINT_WIDTH,"px")}}>30</h6>
      </div>
      <div className="tablecontents__row">
        <img src={appendix} />
        <h5 style={{ fontSize: fontReport(width,PRINT_WIDTH,21/PRINT_WIDTH,"px")}}>Appendices</h5>
      </div>
    </div>
  );
};
